export { default as Share } from './components/share';
export { default as ShareLink } from './components/share-link';



// WEBPACK FOOTER //
// ./src/components/share/index.js